import React from 'react';

interface HeaderProps {
  title?: string;
}

const Header: React.FC<HeaderProps> = ({ title = 'Admin Dashboard' }) => (
  <div className="content-header">
    <div>
      <span className="content-eyebrow">DSS Administration</span>
      <h1>{title}</h1>
    </div>
    <div className="breadcrumb"><i className="bi bi-house-door" /><span>Home</span><i className="bi bi-chevron-right" /><strong>{title}</strong></div>
  </div>
);

export default Header;
